export default __webpack_public_path__ + "static/media/ida-chatbot-icon.6c2e57c2.png";